import { Add } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import {
  OrganizationProposalContent,
  UpdateOrganizationProposalContentMutationVariables,
} from "generated/graphql";
import useGetOrganizationProposalContent from "hooks/organization/useGetorganizationProposalContent";
import useModalState from "hooks/useModalState";
import FormInputWYSIWYG from "./FormInputWYSIWYG";
import useGetOrganization from "hooks/organization/useGetOrganization";
import ProposalDefaults from "./ProposalDefaults";
import EstimatingDefaults from "./EstimatingDefaults";
import ChecklistItemsList from "./ChecklistItemsList";
import LayoutContentSettingsTable from "./LayoutContentSettingsTable";
import AddProposalTermModal from "./AddProposalTermModal";

interface ProposalSettingsListProps {
  loading: boolean;
  onSubmit: (values: UpdateOrganizationProposalContentMutationVariables) => void;
  onHelpClick?: () => void;
}

export default function ProposalSettingsList({
  onSubmit,
  loading,
  onHelpClick,
}: Partial<ProposalSettingsListProps>) {
  const { proposalContent, loading: getContentLoading } = useGetOrganizationProposalContent();
  const { data } = useGetOrganization();
  const { open: modalOpen, onOpen: openModal, onClose: closeModal } = useModalState();

  if (getContentLoading) {
    return null;
  }

  return (
    <MDBox p={3} maxWidth="1150px" mx="auto" mt={1}>
      <EstimatingDefaults />
      {data?.proposalDefaults && (
        <ProposalDefaults proposalDefaults={data.proposalDefaults} onHelpClick={onHelpClick} />
      )}
      <ChecklistItemsList />
      <LayoutContentSettingsTable />

      <MDBox
        className="tour-proposal-terms"
        sx={{ backgroundColor: "#fff", p: "25px", mb: "20px", borderRadius: "8px" }}
      >
        <MDBox mb={2} display="flex" justifyContent="flex-end">
          <MDButton
            className="tour-add-proposal-terms-button"
            variant="gradient"
            color="info"
            size="small"
            startIcon={<Add />}
            onClick={openModal}
            sx={{ cursor: "pointer", "&:hover": { cursor: "pointer" } }}
          >
            Add Proposal Terms
          </MDButton>
        </MDBox>

        {proposalContent.map((content) => (
          <FormInputWYSIWYG
            key={content.id}
            type={content.type}
            content={content}
            onSubmit={onSubmit}
            loading={loading}
          />
        ))}
      </MDBox>

      <AddProposalTermModal open={modalOpen} onClose={closeModal} />
    </MDBox>
  );
}
